import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7faec0ec")

_pushScopeId("data-v-7faec0ec")
const _hoisted_1 = { class: "p-ml-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Filtri ")
const _hoisted_3 = {
  key: 0,
  class: "badge"
}
const _hoisted_4 = {
  key: 1,
  class: "material-icons"
}
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "flexbox-row" }
_popScopeId()

import { reactive, ref, computed, watch } from 'vue';
import UiButton from '../ui/UiButton.vue';
import PadelInput from '@/widgets/input/PadelInput.vue';
import { useI18n } from 'vue-i18n';
import UiAutocomplete from '../ui/UiAutocomplete.vue';
import debounce from 'lodash.debounce';

export type Filter = {
  min_cancellations?: number;
  min_bookings?: number;
  banned: null | boolean;
  name?: string;
}


export default _defineComponent({
  props: {
    filters: { type: Object, required: true }
  } as unknown as undefined,
  emits: ["update:filters"] as unknown as undefined,
  setup(__props: {
  filters: Filter;
}, { emit }: { emit: ({
  (e: 'update:filters', f: typeof currentFilters): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
const { t } = useI18n();

const isVisible = ref(false);



const usersStatus = ref([
  { value: null, label: 'Tutti' },
  { value: true, label: 'Bannati' },
  { value: false, label: 'Attivi' },
])

const appliedFilters = ref(0);

const currentFilters = reactive<Filter>(props.filters)

const currentFiltersNumber = computed(() => {
  let count = 0;
  if (currentFilters.min_bookings > 0) count++;
  if (currentFilters.min_cancellations > 0) count++;
  if (currentFilters.banned !== null) count++;
  if (currentFilters.name && currentFilters.name.trim() !== '') count++;
  return count;
})



const applyFilters = () => {
  emit('update:filters', { ...currentFilters });
  appliedFilters.value = currentFiltersNumber.value;
  isVisible.value = false;
}

const resetFilters = () => {
  currentFilters.min_bookings = undefined;
  currentFilters.min_cancellations = undefined;
  currentFilters.banned = null;
  currentFilters.name = undefined;
  emit('update:filters', { ...currentFilters });
  appliedFilters.value = currentFiltersNumber.value;
  isVisible.value = false;
}

watch(() => currentFilters.name, debounce(applyFilters, 500));

return (_ctx: any,_cache: any) => {
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(PadelInput, {
      value: _unref(currentFilters).name,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_unref(currentFilters).name = $event)),
      label: _unref(t)('search_user_name'),
      "hide-error": "",
      "is-search": "",
      icon: _unref(currentFilters).name ? 'close' : 'search',
      "button-clickable": "",
      onButtonClicked: _cache[2] || (_cache[2] = () => _unref(currentFilters).name = undefined)
    }, null, 8, ["value", "label", "icon"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(UiButton, {
        onClick: _cache[3] || (_cache[3] = () => isVisible.value = true),
        variant: !appliedFilters.value ? 'primary' : 'danger'
      }, {
        "right-icon": _withId(() => [
          (appliedFilters.value)
            ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(appliedFilters.value), 1))
            : (_openBlock(), _createBlock("i", _hoisted_4, "filter_list"))
        ]),
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["variant"]),
      (isVisible.value)
        ? (_openBlock(), _createBlock(_component_DumbModal, {
            key: 0,
            onHide: _cache[8] || (_cache[8] = () => isVisible.value = false),
            title: _unref(t)('filter_club_requests')
          }, {
            footer: _withId(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode(UiButton, {
                  onClick: _cache[7] || (_cache[7] = () => isVisible.value = false),
                  "is-text": "",
                  size: "lg",
                  class: "uppercase"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('abort')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(UiButton, {
                  onClick: resetFilters,
                  "is-text": "",
                  size: "lg",
                  class: "p-ml-auto uppercase"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('reset_filters')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(UiButton, {
                  onClick: applyFilters,
                  size: "lg",
                  class: "p-ml-4 uppercase"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('apply')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withId(() => [
              _createVNode("div", _hoisted_5, [
                _createVNode(PadelInput, {
                  label: _unref(t)('min_bookings'),
                  value: _unref(currentFilters).min_bookings,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_unref(currentFilters).min_bookings = $event)),
                  "input-type": "number"
                }, null, 8, ["label", "value"]),
                _createVNode(PadelInput, {
                  label: _unref(t)('min_cancellations'),
                  value: _unref(currentFilters).min_cancellations,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_unref(currentFilters).min_cancellations = $event)),
                  "input-type": "number"
                }, null, 8, ["label", "value"]),
                _createVNode(UiAutocomplete, {
                  modelValue: _unref(currentFilters).banned,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_unref(currentFilters).banned = $event)),
                  options: usersStatus.value,
                  label: "Stato Utente"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})